import React from 'react';
import {
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  InputLabel,
  FormControl,
  Checkbox,
  FormControlLabel
} from '@mui/material';

// Editor de campos condicionales dentro de sección
const SectionConditionalFieldEditor = ({
  condField,
  condFieldIndex,
  id,
  fieldIndex,
  optionIndex,
  handleSectionConditionalFieldChange,
  handleRemoveSectionConditionalField,
  handleAddSectionConditionalDropboxOption,
  handleRemoveSectionConditionalDropboxOption,
  handleSectionConditionalDropboxOptionChange
}) => (
  <div style={{
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '8px',
    padding: '8px',
    backgroundColor: 'white',
    borderRadius: '4px',
    border: '1px solid #c8e6c9'
  }}>
    <TextField
      size="small"
      placeholder="Nombre del campo"
      value={condField.title || ''}
      onChange={(e) => handleSectionConditionalFieldChange(id, fieldIndex, optionIndex, condFieldIndex, 'title', e.target.value)}
      onClick={(e) => e.stopPropagation()}
      style={{ minWidth: '120px' }}
    />
    <FormControl size="small" style={{ minWidth: '120px' }}>
      <InputLabel>Tipo</InputLabel>
      <Select
        value={condField.type || 'TEXT'}
        label="Tipo"
        onChange={(e) => handleSectionConditionalFieldChange(id, fieldIndex, optionIndex, condFieldIndex, 'type', e.target.value)}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem value="TEXT">Texto</MenuItem>
        <MenuItem value="NUMBER">Número</MenuItem>
        <MenuItem value="DATE">Fecha</MenuItem>
        <MenuItem value="DATE_TIME">Fecha y hora</MenuItem>
        <MenuItem value="EMAIL">Email</MenuItem>
        <MenuItem value="URL">URL</MenuItem>
        <MenuItem value="UPLOAD">Fotografía</MenuItem>
        <MenuItem value="UPLOAD_FILE">Archivos</MenuItem>
        <MenuItem value="SIGNATURE">Firma</MenuItem>
        <MenuItem value="DROPBOX">Dropbox</MenuItem>
      </Select>
    </FormControl>
    <FormControlLabel
      control={
        <Checkbox
          checked={condField.required !== false}
          onChange={(e) => handleSectionConditionalFieldChange(id, fieldIndex, optionIndex, condFieldIndex, 'required', e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          size="small"
        />
      }
      label="Req."
    />
    <Button
      size="small"
      color="error"
      onClick={(e) => {
        e.stopPropagation();
        handleRemoveSectionConditionalField(id, fieldIndex, optionIndex, condFieldIndex);
      }}
    >
      ✕
    </Button>

    {/* Opciones para dropbox condicional anidado */}
    {condField.type === 'DROPBOX' && (
      <div style={{ width: '100%', marginTop: '6px', paddingLeft: '8px' }}>
        <Typography variant="caption" style={{ fontSize: '11px' }}>Opciones:</Typography>
        {(condField.dropbox || []).map((dropOpt, dropOptIndex) => (
          <div key={dropOptIndex} style={{ display: 'flex', gap: '4px', marginTop: '2px' }}>
            <TextField
              size="small"
              value={dropOpt || ''}
              placeholder={`Opción ${dropOptIndex + 1}`}
              onChange={(e) => handleSectionConditionalDropboxOptionChange(id, fieldIndex, optionIndex, condFieldIndex, dropOptIndex, e.target.value)}
              onClick={(e) => e.stopPropagation()}
              style={{ fontSize: '12px' }}
            />
            <Button
              size="small"
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveSectionConditionalDropboxOption(id, fieldIndex, optionIndex, condFieldIndex, dropOptIndex);
              }}
            >
              ✕
            </Button>
          </div>
        ))}
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleAddSectionConditionalDropboxOption(id, fieldIndex, optionIndex, condFieldIndex);
          }}
          style={{ marginTop: '4px', fontSize: '11px' }}
        >
          + Opción
        </Button>
      </div>
    )}
  </div>
);

const SectionFieldEditor = ({
  sectionField,
  fieldIndex,
  id,
  handleSectionFieldChange,
  handleRemoveSectionField,
  handleAddSectionFieldDropboxOption,
  handleRemoveSectionFieldDropboxOption,
  handleSectionFieldDropboxOptionChange,
  // Handlers para campos condicionales dentro de sección
  handleAddSectionConditionalField,
  handleRemoveSectionConditionalField,
  handleSectionConditionalFieldChange,
  handleAddSectionConditionalDropboxOption,
  handleRemoveSectionConditionalDropboxOption,
  handleSectionConditionalDropboxOptionChange
}) => (
  <div style={{
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '10px',
    padding: '10px',
    backgroundColor: 'white',
    borderRadius: '6px',
    border: '1px solid #ffcc80'
  }}>
    <TextField
      size="small"
      placeholder="Nombre del campo"
      value={sectionField.title || ''}
      onChange={(e) => handleSectionFieldChange(id, fieldIndex, 'title', e.target.value)}
      onClick={(e) => e.stopPropagation()}
      style={{ minWidth: '150px' }}
    />
    <FormControl size="small" style={{ minWidth: '150px' }}>
      <InputLabel>Tipo</InputLabel>
      <Select
        value={sectionField.type || 'TEXT'}
        label="Tipo"
        onChange={(e) => handleSectionFieldChange(id, fieldIndex, 'type', e.target.value)}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem value="TEXT">Texto</MenuItem>
        <MenuItem value="NUMBER">Número</MenuItem>
        <MenuItem value="DATE">Fecha</MenuItem>
        <MenuItem value="DATE_TIME">Fecha y hora</MenuItem>
        <MenuItem value="EMAIL">Correo electrónico</MenuItem>
        <MenuItem value="URL">URL</MenuItem>
        <MenuItem value="UPLOAD">Fotografía</MenuItem>
        <MenuItem value="UPLOAD_FILE">Adjuntar archivos</MenuItem>
        <MenuItem value="SIGNATURE">Firma</MenuItem>
        <MenuItem value="DROPBOX">Opción (dropbox)</MenuItem>
      </Select>
    </FormControl>
    <FormControlLabel
      control={
        <Checkbox
          checked={sectionField.required !== false}
          onChange={(e) => handleSectionFieldChange(id, fieldIndex, 'required', e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          size="small"
        />
      }
      label="Requerido"
    />
    <Button
      type="button"
      variant="outlined"
      color="error"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        handleRemoveSectionField(id, fieldIndex);
      }}
    >
      ✕
    </Button>

    {/* Opciones para dropbox dentro de sección */}
    {sectionField.type === 'DROPBOX' && (
      <div style={{ width: '100%', marginTop: '8px', paddingLeft: '10px' }}>
        <Typography variant="caption">Opciones del dropbox:</Typography>
        {(sectionField.dropbox || []).map((dropOpt, dropOptIndex) => (
          <div key={dropOptIndex} style={{ marginBottom: '10px' }}>
            <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
              <TextField
                size="small"
                value={dropOpt || ''}
                placeholder={`Opción ${dropOptIndex + 1}`}
                onChange={(e) => handleSectionFieldDropboxOptionChange(id, fieldIndex, dropOptIndex, e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
              <Button
                size="small"
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveSectionFieldDropboxOption(id, fieldIndex, dropOptIndex);
                }}
              >
                ✕
              </Button>
            </div>
            
            {/* Campos condicionales para esta opción del dropbox */}
            <div style={{ marginLeft: '15px', marginTop: '8px' }}>
              {sectionField.conditionalFields && sectionField.conditionalFields[dropOptIndex] && sectionField.conditionalFields[dropOptIndex].length > 0 && (
                <div style={{
                  padding: '8px',
                  backgroundColor: '#e8f5e9',
                  borderRadius: '4px',
                  border: '1px dashed #4caf50',
                  marginBottom: '8px'
                }}>
                  <Typography variant="caption" style={{ color: '#2e7d32', fontWeight: 'bold', display: 'block', marginBottom: '8px', fontSize: '11px' }}>
                    📋 Campos condicionales (al seleccionar "{dropOpt || `Opción ${dropOptIndex + 1}`}")
                  </Typography>
                  
                  {sectionField.conditionalFields[dropOptIndex].map((condField, condFieldIndex) => (
                    <SectionConditionalFieldEditor
                      key={condFieldIndex}
                      condField={condField}
                      condFieldIndex={condFieldIndex}
                      id={id}
                      fieldIndex={fieldIndex}
                      optionIndex={dropOptIndex}
                      handleSectionConditionalFieldChange={handleSectionConditionalFieldChange}
                      handleRemoveSectionConditionalField={handleRemoveSectionConditionalField}
                      handleAddSectionConditionalDropboxOption={handleAddSectionConditionalDropboxOption}
                      handleRemoveSectionConditionalDropboxOption={handleRemoveSectionConditionalDropboxOption}
                      handleSectionConditionalDropboxOptionChange={handleSectionConditionalDropboxOptionChange}
                    />
                  ))}
                </div>
              )}
              
              <Button
                size="small"
                variant="outlined"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddSectionConditionalField(id, fieldIndex, dropOptIndex);
                }}
                style={{ borderStyle: 'dashed', fontSize: '11px' }}
              >
                + Campo condicional
              </Button>
            </div>
          </div>
        ))}
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleAddSectionFieldDropboxOption(id, fieldIndex);
          }}
          style={{ marginTop: '4px' }}
        >
          + Opción
        </Button>
      </div>
    )}
  </div>
);

const RepeatableSectionFields = ({
  id,
  input,
  handleInputUpdate,
  handleAddSectionField,
  handleRemoveSectionField,
  handleSectionFieldChange,
  handleAddSectionFieldDropboxOption,
  handleRemoveSectionFieldDropboxOption,
  handleSectionFieldDropboxOptionChange,
  // Handlers para campos condicionales dentro de sección
  handleAddSectionConditionalField,
  handleRemoveSectionConditionalField,
  handleSectionConditionalFieldChange,
  handleAddSectionConditionalDropboxOption,
  handleRemoveSectionConditionalDropboxOption,
  handleSectionConditionalDropboxOptionChange
}) => {
  return (
    <div style={{
      marginTop: '15px',
      padding: '15px',
      borderRadius: '8px',
      border: '1px solid #e0e0e0'
    }}>
      <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
        Campos de la sección repetible
      </Typography>
      <Typography variant="caption" style={{ display: 'block', marginBottom: '15px', color: '#666' }}>
        Define los campos que se repetirán cada vez que el usuario añada una nueva instancia.
      </Typography>

      {/* Lista de campos de la sección */}
      {input.sectionFields && input.sectionFields.length > 0 && (
        <div style={{ marginBottom: '15px' }}>
          {input.sectionFields.map((sectionField, fieldIndex) => (
            <SectionFieldEditor
              key={fieldIndex}
              sectionField={sectionField}
              fieldIndex={fieldIndex}
              id={id}
              handleSectionFieldChange={handleSectionFieldChange}
              handleRemoveSectionField={handleRemoveSectionField}
              handleAddSectionFieldDropboxOption={handleAddSectionFieldDropboxOption}
              handleRemoveSectionFieldDropboxOption={handleRemoveSectionFieldDropboxOption}
              handleSectionFieldDropboxOptionChange={handleSectionFieldDropboxOptionChange}
              handleAddSectionConditionalField={handleAddSectionConditionalField}
              handleRemoveSectionConditionalField={handleRemoveSectionConditionalField}
              handleSectionConditionalFieldChange={handleSectionConditionalFieldChange}
              handleAddSectionConditionalDropboxOption={handleAddSectionConditionalDropboxOption}
              handleRemoveSectionConditionalDropboxOption={handleRemoveSectionConditionalDropboxOption}
              handleSectionConditionalDropboxOptionChange={handleSectionConditionalDropboxOptionChange}
            />
          ))}
        </div>
      )}

      <Button
        type="button"
        variant="outlined"
        onClick={(e) => {
          e.stopPropagation();
          handleAddSectionField(id);
        }}
        style={{ borderStyle: 'dashed', marginBottom: '15px' }}
      >
        + Añadir campo a la sección
      </Button>

      {/* Configuración de límites */}
      <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
        <TextField
          size="small"
          type="number"
          label="Mínimo de instancias"
          value={input.minInstances || 1}
          onChange={(e) => handleInputUpdate(id, { minInstances: parseInt(e.target.value) || 1 })}
          onClick={(e) => e.stopPropagation()}
          inputProps={{ min: 1 }}
          style={{ width: '150px' }}
        />
        <TextField
          size="small"
          type="number"
          label="Máximo de instancias"
          value={input.maxInstances || 10}
          onChange={(e) => handleInputUpdate(id, { maxInstances: parseInt(e.target.value) || 10 })}
          onClick={(e) => e.stopPropagation()}
          inputProps={{ min: 1 }}
          style={{ width: '150px' }}
        />
      </div>
    </div>
  );
};

export default RepeatableSectionFields;
